import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiResponse} from "../../base/repository/entity/base.entity";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Feedback} from "./entity/feedback.entity";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FeedbackRepository {

  constructor(private http: HttpClient) {
  }

  getFeedback(companyCode: string, refNum: string): Observable<ApiResponse<Feedback>> {
    const headers = {
      'X-Company': companyCode,
    }
    const requestOptions = {
      headers: new HttpHeaders(headers),
    };
    return this.http.get<ApiResponse<Feedback>>(environment.baseUrl + `/feedback/${refNum}`, requestOptions)
  }

  submitFeedback(companyCode: string, refNum: string, feedback: Feedback): Observable<ApiResponse<Feedback>> {
    const headers = {
      'X-Company': companyCode,
    }
    const requestOptions = {
      headers: new HttpHeaders(headers),
    };
    return this.http.post<ApiResponse<Feedback>>(environment.baseUrl + `/feedback/${refNum}`, feedback, requestOptions)
  }
}
